import {
  CLOSE_REALIGN_MODAL,
  OPEN_REALIGN_MODAL,
  SET_OBJECTIVE_REALIGN_MODAL,
  SET_PARENT_OBJECTIVE_ID_REALIGN_MODAL,
  SET_TIMEBOUND_DETAILS_REALIGN_MODAL,
  SET_SELECTED_OBJECTIVE_REALIGN_MODAL,
} from './actionTypes';

export const openRealignModalAction = ({
  onClose,
  onSelect,
  enableCreation,
  allowTimePeriodChange = true,
  selectedTimeBoundPeriod = null,
  selectedObjective = null,
  objectiveId = null,
  objectiveName = '',
  parentId = null,
  realignId,
  isSelectObjectiveModal = false,
  timeboundIsDisabled,
  showAlignAsParent,
  krName,
  krId,
  isRealignObjective,
  setTimeboundDetails = () => {},
  onSuccess = () => {},
  isObjectiveSidePanel = false,
  isDeleteRealign = false,
  source = '',
}) => ({
  type: OPEN_REALIGN_MODAL,
  payload: {
    onClose,
    onSelect,
    enableCreation,
    allowTimePeriodChange,
    selectedTimeBoundPeriod,
    selectedObjective,
    objectiveId,
    objectiveName,
    realignId,
    isSelectObjectiveModal,
    timeboundIsDisabled,
    showAlignAsParent,
    krName,
    krId,
    setTimeboundDetails,
    isRealignObjective,
    onSuccess,
    isObjectiveSidePanel,
    isDeleteRealign,
    source,
  },
});

export const closeRealignModalAction = () => ({
  type: CLOSE_REALIGN_MODAL,
});

export const setParentObjectiveIdRealignModalAction = ({ parentId }) => ({
  type: SET_PARENT_OBJECTIVE_ID_REALIGN_MODAL,
  payload: {
    parentId,
  },
});

export const setTimeboundDetailsRealignModalAction = ({ timeboundDetails }) => ({
  type: SET_TIMEBOUND_DETAILS_REALIGN_MODAL,
  payload: {
    timeboundDetails,
  },
});

export const setObjectiveRealignModalAction = ({ objective, isParentTagHighlighted }) => ({
  type: SET_OBJECTIVE_REALIGN_MODAL,
  payload: {
    objective,
    isParentTagHighlighted,
  },
});

export const setSelectedObjectiveRealignModalAction = ({ selectedObjective }) => ({
  type: SET_SELECTED_OBJECTIVE_REALIGN_MODAL,
  payload: {
    selectedObjective,
  },
});
